module.exports = "<div class=\"lowy-loading-spinner\" *ngIf=\"visible\">\n    <mat-spinner></mat-spinner>\n    <div class=\"percentage\" *ngIf=\"percentage\">{{percentage}}%</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading-spinner/loading-spinner.component.html
// module id = ./src/app/components/loading-spinner/loading-spinner.component.html
// module chunks = main